import { memo } from "react";

/**
 * FluidBackground isolates the expensive Liquid Silk background blobs.
 * By wrapping this in memo, we ensure React doesn't spend any time
 * reconciling these deeply nested and blur-filtered divs unless
 * functionally necessary.
 */
const FluidBackground = memo(() => {
    return (
        <>
            <div className="bg-noise" />
            <div className="fluid-bg-container text-emerald-accent/5">
                <div className="fluid-blob blob-1" />
                <div className="fluid-blob blob-2" />
                <div className="fluid-blob blob-3" />
            </div>
        </>
    );
});

FluidBackground.displayName = "FluidBackground";

export default FluidBackground;
